export const notificationMessages: {
  [key: string]: { title: string; message: string };
} = {
  /** Looks like you might have missed something.All fields are required for authorization. */
  AllFieldsRequired_CardAuthorization: {
    title: 'Looks like you might have missed something',
    message: 'All fields are required for authorization'
  },
  /** Looks like you might have missed something.All fields are required for checkout. */
  AllFieldsRequired_Checkout: {
    title:
      'Looks like you might have missed something.All fields are required for checkout',
    message: 'All fields are required for checkout'
  },
  /** Huh.Looks like there was an issue loading your saved payment method.Please try again. */
  Account_ErrorLoadingSavedPaymentMethod: {
    title: 'Huh',
    message: 'Looks like there was an issue loading your saved payment method.'
  },
  /** Something went wrong! Your payment method couldn’t be added—please try again. */
  Account_ErrorAddingPaymentMethod: {
    title: 'Something went wrong!',
    message: "Your payment method couldn't be added—please try again"
  },
  /** Uh - oh, user creation failed.Let’s try that again. */
  UserCreationFailed: {
    title: 'Uh - oh',
    message: 'User creation failed. Let’s try that again'
  },
  /** Login failed.Double check that all fields are correct. */
  LoginFailed: {
    title: 'Login Failed',
    message: 'Double check your credentials are correct'
  },
  verifyEmailRequired: {
    title: 'Verification Required',
    message: 'Please verify your email to access your account'
  },

  /** No sweat, but your session timed out.Please reload the page. */
  InvalidSessionSessionTimeout: {
    title: 'Oh no,',
    message: 'Your session timed out, please login again.'
  },
  /** Dang, this portal is not available.Please try again. */
  PortalNotAvailable: {
    title: 'Sorry!',
    message: 'This portal is not available. Please try again'
  },
  /** Oops, looks like there’s an issue with your cart. */
  InvalidCart: {
    title: 'Oops',
    message: 'looks like there’s an issue with your cart'
  },
  /** Whoops, your order failed. \n If you’re having trouble, give us a shout. */
  OrderFailed: {
    title: 'Whoops, your order failed',
    message: 'If you’re having trouble, give us a shout'
  },
  /** We’re having trouble with that consultation.Please try again. */
  UnknownConsultation_PleaseTryAgain: {
    title: 'Please try again',
    message: 'We’re having trouble with that consultation'
  },
  /** We’re having trouble with that question.Please try again. */
  UnknownQuestion_PleaseTryAgain: {
    title: 'Please try again',
    message: 'We’re having trouble with that question'
  },
  /** Whoops, saving was not successful.Please try again. */
  SavingFailed: {
    title: 'Whoops',
    message: 'Saving was not successful.Please try again'
  },
  /** One or more of your files failed to upload.Please check that they are the correct format and try again. */
  UploadingFilesFailed: {
    title: 'One or more of your files failed to upload',
    message: 'Please check that they are the correct format and try again'
  },
  /** Oh no, looks like payment failed.No worries, happens to the best of us. */
  PaymentFailed: {
    title: 'Oh no',
    message: 'Looks like payment failed. No worries, happens to the best of us'
  },
  /** Your payment method was successfully saved.Let’s get shopping. */
  Success_PaymentMethodSaved: {
    title: 'Let’s get shopping',
    message: 'Your payment method was successfully saved'
  },
  /** Good news, your password was saved.Bad news, now you have to remember it. */
  Success_ForgotPassword: {
    title: 'Almost there',
    message: "We sent you an email to verify it's you"
  },

  /** Good news, your password was saved.Bad news, now you have to remember it. */
  Success_PasswordSaved: {
    title: 'Password saved!',
    message: ' Now you have to remember it :)'
  },
  /** Woohoo! Your password was saved successfully. */
  Success_PasswordSavedV2: {
    title: 'Woohoo!',
    message: 'Your password was saved successfully'
  },
  /** Oops—something went wrong.It’s not you, it’s me. */
  GenericFailure_ItsMe: {
    title: 'Oops',
    message: 'Something went wrong. It’s not you, it’s me'
  },
  /** Our bad, something went wrong.Please try again. */
  GenericFailure_PleaseTryAgain: {
    title: 'Our bad',
    message: 'Something went wrong. Please try again'
  },
  /** Whoops, looks like something went wrong. */
  GenericFailure_Short: {
    title: 'Whoops',
    message: 'Looks like something went wrong'
  },
  /** We don’t want to use the word failure, but it looks like something went wrong. */
  GenericFailure: {
    title: 'We don’t want to use the word failure',
    message: 'But it looks like something went wrong'
  },

  /** We don’t want to use the word failure, but it looks like something went wrong. */
  InvalidAddress: {
    title: 'Invalid Address',
    message: 'Make sure all required fields are filled correctly'
  },

  /** Check Health Card Succeeded, now require login. */
  RequireLogin: {
    title: 'Account already exists!',
    message: 'Please login to continue'
  },

  verifyEmailSuccess: {
    title: 'Thank you!',
    message: 'Account verified successfully.'
  }
};
